import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { NgSelectComponent } from '@ng-select/ng-select';
import { concat, Observable, of, Subject } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, switchMap, tap } from 'rxjs/operators';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'app-select-autocomplete',
  templateUrl: './select-autocomplete.component.html',
  styleUrls: ['./select-autocomplete.component.scss'],
})
export class SelectAutocompleteComponent implements OnInit {
  @ViewChild('myNgSelect') myNgSelect!: NgSelectComponent;
  @Input() data: any;
  @Input() disabled: boolean = false;
  @Output() newItemEvent = new EventEmitter<{}>();

  custLoading = false;
  custTypeahead = new Subject<string>();
  items: any = [];
  loading = false;
  selectedItem: any = {};

  is_array = false;

  model: any = {};

  show_addedit_form = false;
  loading_select = false;
  role: any;

  /** Full objects for selected ids — survives typeahead reloads that replace `items`. */
  private selectedItemsById = new Map<any, any>();

  /** Contributors dropdown: first page on open, more on scroll, filtered while searching. */
  private readonly contributorPageSize = 50;
  private contributorOffset = 0;
  private contributorTerm = '';
  private contributorHasMore = false;
  private contributorGeneration = 0;
  private contributorBrowse: any[] = [];
  contributorLoadingMore = false;
  /** Blocks the next-page request from firing again until the list is scrolled off the end. */
  private contributorScrollArmed = true;

  constructor(private cd: ChangeDetectorRef, public apiService: ApiService) { }

  get canEdit(): boolean {
    return !!(
      this.role?.product_addedit ||
      this.role?.track_addedit ||
      this.role?.tips_video_addedit ||
      this.role?.tips_video_inherited_addedit
    );
  }

  get canAddInDropdown(): boolean {
    return !!(this.data?.can_add && this.canEdit);
  }

  get typeaheadMinTermLength(): number {
    if (this.data?.collection === 'contributors') return 0;
    if (this.data?.minTermLength != null) return this.data.minTermLength;
    return 1;
  }

  get hideSelectedOptions(): boolean {
    return !!(this.data?.multiple);
  }

  /** Overall clear (X). Defaults on; pass data.clearable = false to hide. */
  get isClearable(): boolean {
    if (this.data && Object.prototype.hasOwnProperty.call(this.data, 'clearable')) {
      return !!this.data.clearable;
    }
    return true;
  }

  /**
   * Default appends to body (avoids clipping in cards).
   * Pass data.appendTo = null/'' to keep the panel under the input (needed inside ion-content scroll).
   */
  get dropdownAppendTo(): any {
    if (this.data && Object.prototype.hasOwnProperty.call(this.data, 'appendTo')) {
      const value = this.data.appendTo;
      return value == null || value === '' ? undefined : String(value);
    }
    return 'body';
  }

  /** Optional override; default stays ng-select 'auto' so other callers are unchanged. */
  get dropdownPosition(): 'top' | 'bottom' | 'auto' {
    const value = this.data?.dropdownPosition;
    return value === 'top' || value === 'bottom' || value === 'auto' ? value : 'auto';
  }

  // ng-select automatically appends the typed term after addTagText.
  // Keep this static so UI doesn't show the literal "{term}".
  readonly addTagLabel = 'Add Item';

  /** ng-select addTag: create item via API and return it for the dropdown selection. */
  addTagFromDropdown = (name: string): Promise<any> => {
    const trimmed = (name ?? '').trim();
    if (!trimmed) {
      return Promise.reject();
    }
    return new Promise((resolve, reject) => {
      this.apiService.save(this.data.collection, { name: trimmed }).subscribe({
        next: (response: any) => {
          const item = response?.data;
          if (!item?.id) {
            reject();
            return;
          }
          this.cacheContributor(item);
          if (!this.items.some((x) => x.id === item.id)) {
            this.items.push(item);
          }
          resolve(item);
          this.cd.markForCheck();
        },
        error: (err) => reject(err),
      });
    });
  };

  ngOnInit() {
    let role = localStorage.getItem('role_detail');
    if (role) {
      this.role = JSON.parse(role);

      console.log(this.role);
    }
    this._init();
    this.subscribeToCustTypeahead();
  }

  private subscribeToCustTypeahead() {
    this.custTypeahead.pipe(
      debounceTime(250),
      distinctUntilChanged(),
      tap((term) => this.loadItems(term)),
    ).subscribe();
  }

  onDropdownOpen() {
    if (this.data?.collection !== 'contributors') return;
    if (this.contributorTerm === '' && this.contributorOffset > 0) return;
    void this.loadContributorPage(true, '');
  }

  onContributorScrollToEnd() {
    if (this.data?.collection !== 'contributors') return;
    if (!this.contributorScrollArmed || !this.contributorHasMore || this.contributorLoadingMore || this.custLoading) {
      return;
    }
    this.contributorScrollArmed = false;
    void this.loadContributorPage(false);
  }

  /** Re-arm the next page only after the user scrolls away from the bottom. */
  onContributorPanelScroll(position: { start: number; end: number }) {
    if (this.data?.collection !== 'contributors') return;
    const total = Array.isArray(this.items) ? this.items.length : 0;
    const atEnd = total > 0 && position?.end >= total - 1;
    if (!atEnd) {
      this.contributorScrollArmed = true;
    }
  }


  _init() {
    // console.log(this.data.collection,this.data.item);
    this.loading = true;
    this.custLoading = true;
    let _canLoad = true;
    if (this.data.item) {
      if (this.selectedItem?.id == this.data.item?.id) {
        _canLoad = false;
      }

      //check if array
      if (Array.isArray(this.data.item)) {
        console.log('Array');
        this.is_array = true;
        this.selectedItem = [];
        this.data.item.forEach(item => {
          if (item.name) {
            const id = item.id ?? item.name;
            const option = { ...item, id, name: item.name };
            this.cacheContributor(option);
            this.items.push({ id, name: item.name });
            this.selectedItem.push(id);
          }
        });
        // this.selectedItem=this.data.item;
        _canLoad = false;
      } else {

        this.selectedItem = this.data.item.id ?? this.data.item ?? {};



        _canLoad = false;

        if (this.data.return == 'name') {
          let random_id = Math.random();
          this.selectedItem = { id: random_id, name: this.data.item };
        }

        if (this.data.item?.name) {
          this.items.push({ id: this.data.item.id, name: this.data.item.name })
        }
        this.items.push(this.selectedItem);
        console.log(this.items);
        _canLoad = false;
      }
    }

    // if(this.item != this.selectedPerson || !this.selectedPerson){
    setTimeout(() => {
      this.loading = false;
      this.custLoading = false;
    }, 3000);

    if (_canLoad && this.data?.collection !== 'contributors') {
      this.loadItems();
    }
    // }
  }

  trackByFn(item: any) {
    return item.id;
  }

  chipDisplayName(item: any): string {
    if (item == null) return '';
    if (typeof item === 'string' || typeof item === 'number') {
      const cached = this.getContributorById(item);
      return String(cached?.name ?? item).trim();
    }
    const fromItem = String(item.name || '').trim();
    if (fromItem) return fromItem;
    const cached = this.getContributorById(item.id);
    return String(cached?.name || '').trim();
  }

  private cacheContributor(item: any) {
    if (item?.id != null) {
      this.selectedItemsById.set(item.id, item);
    }
  }

  private cacheContributors(items: any[]) {
    (items ?? []).forEach((item) => this.cacheContributor(item));
  }

  private getContributorById(id: any): any {
    return this.items.find((x) => x.id === id) ?? this.selectedItemsById.get(id);
  }

  private getSelectedIds(): any[] {
    if (Array.isArray(this.selectedItem)) {
      return this.selectedItem;
    }
    if (this.selectedItem == null || this.selectedItem === '') {
      return [];
    }
    return [this.selectedItem?.id ?? this.selectedItem];
  }

  private mergeWithSelectedItems(fetched: any[]): any[] {
    const merged = [...(fetched ?? [])];
    const seen = new Set(merged.map((i) => i.id));
    for (const id of this.getSelectedIds()) {
      const cached = this.getContributorById(id);
      if (cached?.id != null && !seen.has(cached.id)) {
        merged.push(cached);
        seen.add(cached.id);
      }
    }
    return merged;
  }

  private resolveSelectedObjects(value: any): any[] {
    const raw = Array.isArray(value) ? value : value != null ? [value] : [];
    return raw
      .map((entry) => {
        if (entry && typeof entry === 'object' && entry.id != null) {
          return entry;
        }
        const id = entry?.id ?? entry;
        return this.getContributorById(id);
      })
      .filter((x) => x?.id != null);
  }

  async loadItems(term?) {
    console.log(term, this.data);
    const trimmed = (term ?? '').toString().trim();
    if (this.data?.collection === 'contributors') {
      if (trimmed === this.contributorTerm && this.contributorOffset > 0) {
        this.custLoading = false;
        return;
      }
      await this.loadContributorPage(true, trimmed);
      return;
    }

    let filter: any = {};
    let limit = this.data?.limit ?? 10000;
    if (trimmed) {
      switch (this.data?.collection) {

        case 'customers':
          filter = { "_or": [{ name: { '_contains': trimmed } }] };

          if (isNaN(trimmed) === false) {
            filter._or.push({ idseq_app: { '_eq': trimmed } });
          }

          break;

        case 'tracks':
          filter = { "_or": [{ name: { '_contains': trimmed } }, { isrc: { '_contains': trimmed } }] };
          limit = 100;
          break;

        default:
          filter = { "_or": [{ name: { '_contains': trimmed } }] };
          break;

      }

    }
    try {
      this.custLoading = true;
      // filter.app=this.apiService.current_active_app.id;
      const x = await this.apiService.get(this.data.collection, { filter: filter, limit: limit }, false);

      if (x && x.data.length > 0) {
      this.items = this.mergeWithSelectedItems(x.data);
      // Ensure items are sorted alphabetically by name for A-Z ordering
      this.items.sort((a, b) => (a.name || '').localeCompare(b.name || ''));
      } else {
        this.items = this.mergeWithSelectedItems([]);
        // Ensure empty list remains sorted (no effect)
        this.items.sort((a, b) => (a.name || '').localeCompare(b.name || ''));
      }

      console.log('x', x);

      this.custLoading = false;
      this.cd.markForCheck();
    } catch (error) {
      console.error('Error:', error);
      this.items = this.mergeWithSelectedItems([]);
    }


  }

  /** A–Z pages. Search replaces the list; scrolling the open list appends the next page. */
  private async loadContributorPage(reset: boolean, term?: string): Promise<void> {
    const trimmed = reset ? String(term ?? '').trim() : this.contributorTerm;
    if (!reset && (!this.contributorHasMore || this.contributorLoadingMore || this.custLoading)) {
      return;
    }

    const generation = reset ? ++this.contributorGeneration : this.contributorGeneration;
    if (reset) {
      this.contributorOffset = 0;
      this.contributorHasMore = true;
      this.contributorTerm = trimmed;
      this.contributorScrollArmed = true;
      this.custLoading = true;
      this.contributorLoadingMore = false;
    } else {
      this.contributorLoadingMore = true;
    }
    this.cd.markForCheck();

    const params: Record<string, unknown> = {
      limit: this.contributorPageSize,
      offset: this.contributorOffset,
      sort: 'name',
      fields: 'id,name',
    };
    if (trimmed) {
      params['filter'] = { name: { _icontains: trimmed } };
    }

    try {
      let result: any;
      try {
        result = await this.apiService.get(this.data.collection, params, false);
      } catch {
        const fallback = { ...params };
        delete fallback['fields'];
        result = await this.apiService.get(this.data.collection, fallback, false);
      }
      if (generation !== this.contributorGeneration) return;

      const batch = Array.isArray(result?.data) ? result.data : [];
      const named = batch
        .map((row: any) => ({ ...row, name: String(row?.name || '').trim() }))
        .filter((row: any) => row?.id != null && row.name);
      if (reset) {
        this.contributorBrowse = named;
      } else {
        const seen = new Set(this.contributorBrowse.map((row) => row.id));
        this.contributorBrowse = [
          ...this.contributorBrowse,
          ...named.filter((row) => !seen.has(row.id)),
        ];
      }
      this.contributorOffset += batch.length;
      this.contributorHasMore = batch.length >= this.contributorPageSize;
      this.items = this.sortByName(this.mergeWithSelectedItems(this.contributorBrowse));
    } catch (error) {
      if (generation !== this.contributorGeneration) return;
      console.error('Error:', error);
      if (reset) {
        this.contributorBrowse = [];
        this.contributorHasMore = false;
        this.items = this.sortByName(this.mergeWithSelectedItems([]));
      }
    } finally {
      if (generation === this.contributorGeneration) {
        this.custLoading = false;
        this.contributorLoadingMore = false;
        this.cd.markForCheck();
      }
    }
  }

  private sortByName(items: any[]): any[] {
    return [...items].sort((a, b) =>
      String(a?.name || '').localeCompare(String(b?.name || ''), 'en', { sensitivity: 'base' })
    );
  }

  onInputChange(event: any) {
    const inputValue: string = event.target.value;

    // Emit the input value to trigger typeahead
    //      this.custTypeahead.next(inputValue);

    // If the input is empty, manually emit an empty string to trigger typeahead
    if (inputValue === '') {
      this.custTypeahead.next('');
    }
  }

  /** Per-chip X. Optional data.confirmBeforeRemove(item) — used by TIPS Video Contributors. */
  async onRemoveChip(item: any, event?: Event, clear?: (item: any) => void) {
    event?.preventDefault?.();
    event?.stopPropagation?.();
    if (this.disabled || !this.canEdit) return;

    if (typeof this.data?.confirmBeforeRemove === 'function') {
      const ok = await this.data.confirmBeforeRemove(item);
      if (!ok) {
        this.cd.markForCheck();
        return;
      }
      const id = item?.id ?? item;
      if (Array.isArray(this.selectedItem)) {
        this.selectedItem = this.selectedItem.filter((entry) => (entry?.id ?? entry) !== id);
        this.setNewItem(this.resolveSelectedObjects(this.selectedItem));
      } else {
        this.selectedItem = null;
        this.setNewItem(null);
      }
      this.cd.markForCheck();
      return;
    }

    if (typeof clear === 'function') {
      clear(item);
    }
  }

  /** Overall ng-select clear — must update parent model (not only local selectedItem). */
  async onClearAll() {
    if (typeof this.data?.confirmBeforeClear === 'function') {
      // Restore chips immediately so the field is not empty while the popup is open.
      if (typeof this.data?.prepareClearConfirm === 'function') {
        this.data.prepareClearConfirm();
      }
      this.restoreSelectionFromDataItem();
      this.cd.detectChanges();

      const ok = await this.data.confirmBeforeClear();
      if (!ok) {
        this.restoreSelectionFromDataItem();
        this.cd.markForCheck();
        return;
      }
      if (this.data?.multiple || this.is_array) {
        this.selectedItem = [];
      } else {
        this.selectedItem = null;
      }
      this.setNewItem(this.data?.multiple || this.is_array ? [] : null);
      this.cd.markForCheck();
      return;
    }
    if (this.data?.multiple || this.is_array) {
      this.selectedItem = [];
      this.setNewItem([]);
    } else {
      this.selectedItem = null;
      this.setNewItem(null);
    }
    this.cd.markForCheck();
  }

  private restoreSelectionFromDataItem() {
    if (Array.isArray(this.data?.item)) {
      this.is_array = true;
      this.selectedItem = [];
      this.data.item.forEach((item: any) => {
        if (!item?.name) return;
        const id = item.id ?? item.name;
        const option = { ...item, id, name: item.name };
        this.cacheContributor(option);
        if (!this.items.some((x) => x.id === id)) {
          this.items.push({ id, name: item.name });
        }
        this.selectedItem.push(id);
      });
      return;
    }
    if (this.data?.multiple) {
      this.selectedItem = [];
      return;
    }
    this.selectedItem = this.data?.item?.id ?? this.data?.item ?? null;
  }

  setNewItem(value: any) {
    console.log("EmitPre", value);
    if (this.is_array && this.data?.return === 'object') {
      const resolved = this.resolveSelectedObjects(value);
      this.cacheContributors(resolved);
      this.selectedItem = resolved.map((x) => x.id);
      value = resolved;
    } else if (this.data?.return == 'id') {
      value = value?.id ?? value;
    } else if (this.data?.return == 'object') {
      value = value;
    } else if (this.data?.return == 'name') {
      value = value.name;
    } else {
      value = value?.id ?? value;
    }
    console.log("EmitPost", value);
    console.log(this.selectedItem, this.items);
    this.newItemEvent.emit(value);
  }
  otherFormSubmit() {
    this.loading_select = true;
    this.apiService.save(this.data.collection, this.model).subscribe((response: any) => {
      this.show_addedit_form = false;

      if (this.is_array) {
        this.cacheContributor(response.data);
        if (!this.items.some((x) => x.id === response.data.id)) {
          this.items.push(response.data);
        }
        if (!Array.isArray(this.selectedItem)) {
          this.selectedItem = [];
        }
        if (!this.selectedItem.includes(response.data.id)) {
          this.selectedItem.push(response.data.id);
        }

        const selectedItems: any[] = [];
        this.selectedItem.forEach((id) => {
          if (id) {
            const selected_itemm = this.getContributorById(id);
            if (selected_itemm?.id) {
              selectedItems.push(selected_itemm);
            }
          }
        });

        this.setNewItem(selectedItems);
      } else {
        this.selectedItem = response.data.id;
        this.setNewItem(response.data);
      }
      console.log(this.selectedItem, response.data, this.items);

      this.model = {};
      this.loading_select = false;
      if (this.data?.collection === 'contributors') {
        void this.loadItems();
      }
    });
  }

  isSelected(itemId: any): boolean {
    return this.data.selectedItems.includes(itemId);
  }

  isSelectedTrackCon(itemID: any): boolean {
    //  console.log(this.data.selectedItemsTracksCon);
    return this.data.selectedItemsTracksCon.includes(itemID);
  }



  openAddForm() {
    this.model = {};
    this.show_addedit_form = true;
  }

  closeAddForm() {
    this.show_addedit_form = false;
    this.model = {};
  }

  addItem(searchItem: any) {
    this.myNgSelect.close();
    this.model = { name: searchItem };
    this.show_addedit_form = true;
  }
}